const stats = [
  { num: "120+", label: "收录治愈番" },
  { num: "20+", label: "主题片单" },
  { num: "8w+", label: "暖心读者" },
];

function Hero() {
  return (
    <section
      id="home"
      className="relative w-full overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20soft%20watercolor%20anime%20illustration%20of%20a%20cute%20puppy%20relaxing%20on%20a%20cozy%20couch%20watching%20tv%2C%20surrounded%20by%20floating%20anime%20frames%2C%20hot%20drink%20and%20blanket%2C%20cream%20peach%20and%20soft%20orange%20palette%2C%20gentle%20healing%20atmosphere%2C%20dreamy%20soft%20lighting%2C%20stylish%20flat%20illustration&width=1600&height=900&seq=hero-dog-16&orientation=landscape"
          alt="小狗看番——一只温暖的小狗窝在沙发上看治愈番"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/20 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-7xl flex-col items-center justify-center px-4 md:px-6 py-24 md:min-h-[640px] text-center">
        <span className="mb-5 inline-flex items-center gap-1.5 rounded-full bg-secondary-100/90 px-4 py-1.5 text-xs font-medium text-secondary-900">
          <i className="ri-heart-3-fill text-primary-500"></i>
          每周更新的治愈系片单合集
        </span>

        <h1 className="font-heading text-4xl md:text-6xl text-foreground-950 leading-tight">
          想看轻松治愈番？
          <br />
          <span className="text-primary-600">小狗看番</span>帮你慢慢挑
        </h1>

        <p className="mt-6 max-w-2xl text-base md:text-lg text-foreground-700 leading-relaxed">
          想找能放松心情、看完心里暖暖的番？我们按
          <strong className="text-primary-700">治愈番推荐</strong>、
          <strong className="text-accent-700">日常系合集</strong>、
          <strong className="text-secondary-800">温馨萌系动画</strong>分类整理，
          帮你快速挑到合口味的下饭治愈作，追更不迷路。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#featured"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            看看今日推荐
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#categories"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-full bg-background-50/90 border border-background-200 px-6 py-3 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors"
          >
            浏览分类片单
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-2xl grid-cols-3 gap-3 md:gap-5">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-50/80 backdrop-blur-sm border border-background-200/70 px-3 py-4 text-center"
            >
              <div className="font-heading text-2xl md:text-3xl text-primary-600">
                {s.num}
              </div>
              <div className="mt-1 text-xs md:text-sm text-foreground-700">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;